function CaliforniaPrivacyRights() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="prose prose-lg max-w-none">
        <h1 className="text-3xl font-bold mb-8">California Privacy Rights</h1>

        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-8">
          <p className="text-blue-700">
            Special privacy rights notice for California residents
          </p>
        </div>

        <section className="space-y-6">
          <div>
            <h2 className="text-2xl font-semibold mb-4">Information Request Rights</h2>
            <p>
              If you are a California resident, California Civil Code Section 1798.83 permits you to request 
              information regarding the disclosure of your personal information by Content Creator AI to third 
              parties for the third parties' direct marketing purposes. To make such a request, please send 
              an email to{' '}
              <a href="mailto:contact@contentcreatorai.com" className="text-primary hover:text-primary-dark">
                contact@contentcreatorai.com
              </a>
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4">Our Commitment</h2>
            <p>
              We take great pride in the relationship of trust and we are dedicated to treating your personal 
              information with care and respect. Pursuant to California Civil Code Section 1798.83(c)(2), 
              Content Creator AI does not share guests' personal information with other companies or others 
              outside for those parties' direct marketing use unless a guest elects that we do so.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4">Additional Privacy Information</h2>
            <p>
              For more information about our privacy and data collection policies, you may wish to review 
              our{' '}
              <a href="/privacy-policy" className="text-primary hover:text-primary-dark">
                Privacy Policy
              </a>.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4">Rights for Minors</h2>
            <p>
              If you are a California resident under the age of 18, and a registered user of any site where 
              this policy is posted, California Business and Professions Code Section 22581 permits you to 
              request and obtain removal of content or information you have publicly posted.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4">Content Removal Requests</h2>
            <p>
              To make such a request, please send an email with a detailed description of the specific content 
              or information to{' '}
              <a href="mailto:contact@contentcreatorai.com" className="text-primary hover:text-primary-dark">
                contact@contentcreatorai.com
              </a>.
            </p>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-4">
              <p className="text-yellow-700">
                Please be aware that such a request does not ensure complete or comprehensive removal of the 
                content or information you have posted and that there may be circumstances in which the law 
                does not require or allow removal even if requested.
              </p>
            </div>
          </div>
        </section>

        <div className="mt-12 text-sm text-gray-600">
          Last updated: December 23, 2024
        </div>
      </div>
    </div>
  );
}

export default CaliforniaPrivacyRights;
